import { render } from "./tenPage.vue?vue&type=template&id=e7c13988&scoped=true"
import script from "./tenPage.vue?vue&type=script&lang=js"
export * from "./tenPage.vue?vue&type=script&lang=js"

import "./tenPage.vue?vue&type=style&index=0&id=e7c13988&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7c13988"]])

export default __exports__